var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { logger } from '~/classes/Logger';
import { Fonts } from '~/components';
import { FontFamilyType, StatusFetch } from '~/enum';
const useFetchFonts = () => {
    const [status, setStatus] = useState(StatusFetch.IDLE);
    const loadFonts = (controller) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setStatus(StatusFetch.LOADING);
            const regularFont = new FontFace(FontFamilyType.REGULAR, `url(${Fonts.baiJamjureeRegular})`);
            const boldFont = new FontFace(FontFamilyType.BOLD, `url(${Fonts.baiJamjureeBold})`);
            const mediumFont = new FontFace(FontFamilyType.MEDIUM, `url(${Fonts.baiJamjureeMedium})`);
            const semiBoldFont = new FontFace(FontFamilyType.SEMIBOLD, `url(${Fonts.baiJamjureeSemiBold})`);
            const boldItalicFont = new FontFace(FontFamilyType.BOLD_ITALIC, `url(${Fonts.baiJamjureeBoldItalic})`);
            const [regular, bold, medium, semiBold, boldItalic] = yield Promise.all([
                yield regularFont.load(),
                yield boldFont.load(),
                yield mediumFont.load(),
                yield semiBoldFont.load(),
                yield boldItalicFont.load(),
            ]);
            document.fonts.add(regular);
            document.fonts.add(bold);
            document.fonts.add(medium);
            document.fonts.add(semiBold);
            document.fonts.add(boldItalic);
            if (controller.signal.aborted) {
                logger.info('Sprite sheet loading was aborted');
                return;
            }
            setStatus(StatusFetch.SUCCESS);
        }
        catch (error) {
            logger.error('Error loading sprite sheet:', error);
            setStatus(StatusFetch.ERROR);
        }
    });
    useEffect(() => {
        const controller = new AbortController();
        loadFonts(controller);
        return () => controller.abort();
    }, []);
    return {
        status,
    };
};
export default useFetchFonts;
